import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import UnprocessedFileItem from './Item';
import NoData from '../../page/NoData';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('UNPROCESSED_FILES_LIST', LOG_LEVELS.ERROR);

class UnprocessedFilesList extends Component {
  render() {
    log.debug('render(): ', this.props);
    
    if(!Array.isArray(this.props.documents) || this.props.documents.length === 0) {
      return (
        <div>
           <NoData noDataText="importTransactions_NoData" />
        </div>
      )
    }
    return (      
      <table className="card-table">
        <thead>
          <UnprocessedFileItem header={true}/>
        </thead>
        <tbody>
          {
            this.props.documents.map((document, index) => {
              return (
                <UnprocessedFileItem key={index} document={document}/>
              )
            })
          }
        </tbody>
      </table>
    );   
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(UnprocessedFilesList);
